(() => {
  const body = document.body;
  const header = document.querySelector('[data-site-header]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const drawerBackdrop = document.querySelector('[data-drawer-backdrop]');
  const cartItems = document.querySelector('[data-cart-items]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const toast = document.querySelector('[data-toast]');

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[character]));

  const money = (cents) => {
    const format = window.NKTheme?.moneyFormat || '${{amount}}';
    const amount = (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-open');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-open'), 2300);
  };

  const updateBodyLock = () => {
    const open = cartDrawer?.classList.contains('is-open') || searchOverlay?.classList.contains('is-open') || mobileMenu?.classList.contains('is-open');
    body.classList.toggle('nk-no-scroll', Boolean(open));
  };

  const openCart = () => {
    cartDrawer?.classList.add('is-open');
    drawerBackdrop?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    updateBodyLock();
  };

  const closeCart = () => {
    cartDrawer?.classList.remove('is-open');
    drawerBackdrop?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    updateBodyLock();
  };

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
    const label = document.querySelector('[data-cart-label]');
    const total = document.querySelector('[data-cart-total]');
    if (label) label.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    if (total) total.innerHTML = money(cart.total_price);
    if (!cartItems) return;

    if (!cart.item_count) {
      cartItems.innerHTML = '<p class="nk-cart-empty">Your next arc is waiting.</p>';
      return;
    }

    cartItems.innerHTML = cart.items.map((item, index) => `
      <article class="nk-cart-row">
        ${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="">` : ''}
        <div>
          <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          <small>${escapeHtml(item.variant_title || '')} · Qty ${item.quantity}</small>
          <button type="button" data-cart-remove="${index + 1}">Remove</button>
        </div>
        <strong>${money(item.final_line_price)}</strong>
      </article>
    `).join('');
  };

  const refreshCart = async () => {
    const response = await fetch(`${window.NKTheme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart could not be refreshed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      try { await refreshCart(); } catch (error) { /* Existing Liquid cart remains usable. */ }
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]') || event.target.closest('[data-drawer-backdrop]')) {
      closeCart();
      return;
    }
    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      removeButton.disabled = true;
      try {
        const response = await fetch(`${window.NKTheme.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(removeButton.dataset.cartRemove), quantity: 0 })
        });
        if (!response.ok) throw new Error('Item could not be removed');
        renderCart(await response.json());
      } catch (error) {
        showToast('Please try again');
        removeButton.disabled = false;
      }
      return;
    }
    if (event.target.closest('[data-search-open]')) {
      searchOverlay?.classList.add('is-open');
      searchOverlay?.setAttribute('aria-hidden', 'false');
      updateBodyLock();
      window.setTimeout(() => searchOverlay?.querySelector('input[type="search"]')?.focus(), 180);
      return;
    }
    if (event.target.closest('[data-search-close]')) {
      searchOverlay?.classList.remove('is-open');
      searchOverlay?.setAttribute('aria-hidden', 'true');
      updateBodyLock();
      return;
    }
    if (event.target.closest('[data-menu-open]')) {
      mobileMenu?.classList.add('is-open');
      mobileMenu?.setAttribute('aria-hidden', 'false');
      updateBodyLock();
      return;
    }
    if (event.target.closest('[data-menu-close]') || event.target.closest('[data-mobile-menu] a')) {
      mobileMenu?.classList.remove('is-open');
      mobileMenu?.setAttribute('aria-hidden', 'true');
      updateBodyLock();
      return;
    }
    const filterButton = event.target.closest('[data-filter]');
    if (filterButton) {
      const section = filterButton.closest('[data-filter-section]');
      section?.querySelectorAll('[data-filter]').forEach((button) => button.classList.remove('is-active'));
      filterButton.classList.add('is-active');
      section?.querySelectorAll('.nk-product-card').forEach((card) => {
        card.classList.toggle('is-hidden', filterButton.dataset.filter !== 'all' && card.dataset.category !== filterButton.dataset.filter);
      });
      return;
    }
    const demoButton = event.target.closest('[data-demo-add]');
    if (demoButton) {
      showToast(`${demoButton.dataset.productName} · connect a Shopify product to activate`);
    }
  });

  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      const original = submit.innerHTML;
      submit.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.NKTheme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Product could not be added');
        await refreshCart();
        openCart();
      } catch (error) {
        showToast('This piece could not be added');
      } finally {
        submit.disabled = false;
        submit.innerHTML = original;
      }
    });
  });

  document.querySelectorAll('[data-country-selector]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeCart();
    searchOverlay?.classList.remove('is-open');
    searchOverlay?.setAttribute('aria-hidden', 'true');
    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    updateBodyLock();
  });

  if (header) {
    const updateHeader = () => header.classList.toggle('is-sticky', window.scrollY > 120);
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  const revealTargets = document.querySelectorAll(
    '.nk-universe-card, .nk-product-card, .nk-story-copy, .nk-faq-list details'
  );

  revealTargets.forEach((element) => element.classList.add('nk-reveal'));

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    revealTargets.forEach((element) => revealObserver.observe(element));
  } else {
    revealTargets.forEach((element) => element.classList.add('is-visible'));
  }
})();
